module.exports = __webpack_public_path__ + "static/img/GroupTEXT.18a848b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/GroupTEXT.png
// module id = uYfk
// module chunks = 1